<template>
    <label
        class="ds-settings-number"
        :class="{
            'is-changed': changed,
            'is-invalid': invalid,
            'is-disabled': disabled,
        }"
        :title="invalid ? errorText : undefined"
    >
        <input
            :id="inputId"
            class="ds-settings-number-input"
            type="text"
            inputmode="numeric"
            autocomplete="off"
            :value="modelValue ?? ''"
            :maxlength="maxLength"
            :disabled="disabled"
            :placeholder="placeholder"
            :aria-label="label"
            :aria-invalid="invalid || undefined"
            :aria-describedby="invalid && errorText ? `${inputId}-error` : undefined"
            @input="emit('update:modelValue', ($event.target as HTMLInputElement).value)"
            @blur="emit('blur')"
        >
        <span v-if="unit" class="ds-settings-number-unit">{{ unit }}</span>
        <span v-if="invalid && errorText" :id="`${inputId}-error`" class="sr-only">{{ errorText }}</span>
    </label>
</template>

<script setup lang="ts">
// RD-163: числовое поле таблиц настроек 110×32 с единицей внутри (макет D).
// Значение — текст: пустое/невалидное не превращается в 0, проверку делает редактор.
import { useId } from 'vue'

withDefaults(defineProps<{
    modelValue: string | null
    label: string
    unit?: string
    changed?: boolean
    invalid?: boolean
    errorText?: string
    disabled?: boolean
    placeholder?: string
    maxLength?: number
}>(), {
    maxLength: 10,
})

const emit = defineEmits<{
    (event: 'update:modelValue', value: string): void
    (event: 'blur'): void
}>()

const inputId = `settings-number-${useId()}`
</script>
